export default "__VITE_ASSET__Qv0iigQl__"